import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getTransferList } from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditTransferModal from './Add_Edit/AddEditTransferModal';
import DeleteTransfer from './Delete/DeleteTransfer';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';

const TransfersList = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorTransfers = createSelector(
		state => state.Transfers,
		transfer => ({
			transferList: transfer.transferList,
			isLoadingList: transfer.isLoadingList,
			isTransferSuccess: transfer.isTransferSuccess,
			error: transfer.error,
			isAdding: transfer.isAdding,
			isAdded: transfer.isAdded,
			isAddError: transfer.isAddError,
			isUpdating: transfer.isUpdating,
			isUpdated: transfer.isUpdated,
			isUpdateError: transfer.isUpdateError,
			isDeleting: transfer.isDeleting,
			isDeleted: transfer.isDeleted,
			isDeleteError: transfer.isDeleteError,
		})
	);

	const { transferList, isLoadingList } = useSelector(selectorTransfers);

	useEffect(() => {
		dispatch(getTransferList());
	}, []);

	const [dataTransfer, setDataTransfer] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Transfer
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = transfer => {
		setDataTransfer(transfer);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = transfer => {
		setDataTransfer(transfer);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'transfer',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const transferData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(transferData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const transferData =
														cellProps.row.original;
													handleClickDelete(transferData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Patente', accessorKey: 'patent', size: 'auto' },
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{
				header: 'Empresa de Transporte',
				accessorKey: 'transfer_company.name',
				size: 'auto',
			},
			{
				header: 'Categoría de transporte',
				accessorKey: 'transfer_category.name',
				size: 'auto',
			},
			{
				header: 'Tipo de transporte',
				accessorKey: 'transfer_type.name',
				size: 'auto',
			},
		],
		[handleClickEdit]
	);

	console.log(transferList)

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataTransfer({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Transporte
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody>
							<ODataGrid
								columns={columns}
								data={transferList || []}
								isLoadingData={isLoadingList}
								nameFile={'transportes'}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataTransfer({});
											handleToggleModal();
										},
										title: 'Crear Transporte',
									}
								]}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditTransferModal
				dataTransfer={dataTransfer}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteTransfer
				dataTransfer={dataTransfer}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default TransfersList;
